var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDvtBenefits5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 461,
    height: 311,
    viewBox: "0 0 461 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_837_238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 453,
    height: 303,
    rx: 8,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.683 164.88L156.267 167.954L162.076 252.875L188.759 255.029C188.759 255.029 194.559 222.381 194.89 217.078C195.222 211.774 185.456 172.006 185.456 172.006L174.683 164.88Z",
    fill: "#3561E4",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.89 298.014C202.309 296.417 202.915 293.673 202.775 291.574C202.565 288.428 201.726 283.603 201.726 283.603L194.176 284.233L197.097 298.014H201.89Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.859 298.014H197.282C197.071 296.332 196.529 292.093 195.885 287.842C195.056 282.373 189.421 244.09 189.421 244.09L133.24 238.787C133.24 238.787 120.147 264.143 118.324 271.601C116.501 279.059 120.644 296.626 120.644 296.626L120.859 298.014Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194.89 107.201C194.89 107.201 199.199 106.206 201.022 113.001C202.845 119.796 200.69 123.276 201.519 126.591C202.347 129.906 204.123 137.686 201.968 145.475C199.814 153.264 192.072 158.907 191.74 161.725C191.409 164.543 191.409 164.543 191.409 164.543C191.409 164.543 190.249 165.703 186.603 165.371C182.957 165.04 178.482 162.388 178.482 162.388L178.979 156.753C178.979 156.753 185.277 156.753 186.768 155.593C188.26 154.432 194.723 142.997 195.221 139.683C195.718 136.368 196.05 126.922 195.552 124.104C195.055 121.287 191.575 115.486 190.249 114.989C188.923 114.492 182.791 110.183 182.791 110.183C182.791 110.183 191.244 105.046 194.89 107.201Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.034 178.463C199.034 178.463 204.337 180.949 204.503 185.093C204.669 189.236 201.685 207.631 201.685 208.957C201.685 210.283 200.194 237.794 200.194 237.794L203.404 285.702L195.853 286.122C195.853 286.122 189.256 250.721 189.919 246.412C190.582 242.103 194.56 220.89 194.891 217.078C195.222 213.267 194.394 197.025 195.554 192.219C196.713 187.412 199.034 178.463 199.034 178.463Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.699 110.812C187.699 110.812 195.884 114.161 197.21 119.961C198.536 125.761 196.548 133.053 197.21 137.694C197.873 142.334 191.244 153.935 188.924 156.752C186.604 159.57 180.97 158.575 180.97 158.575L181.81 167.862C181.81 167.862 185.278 179.457 184.781 182.44C184.284 185.423 178.803 189.801 171.855 189.401C163.237 188.904 160.577 180.88 160.577 180.88L161.737 162.484C161.737 162.484 162.243 157.913 161.414 151.118C160.585 144.323 162.408 134.048 163.071 132.391C163.734 130.733 169.866 123.938 173.678 121.287C177.489 118.635 184.947 111.012 184.947 111.012C184.947 111.012 187.137 110.115 187.699 110.812Z",
    fill: "#FFA88F",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.406 165.964C161.406 165.964 135.892 168.354 132.246 170.839C128.6 173.325 133.903 226.524 133.903 226.524C133.903 226.524 113.353 271.602 114.016 271.933C114.678 272.264 124.457 280.386 134.898 282.209C145.339 284.032 160.585 285.358 160.585 285.358C160.585 285.358 166.054 240.611 166.717 237.131C167.38 233.651 165.225 199.18 165.557 194.374C165.889 189.567 161.406 165.964 161.406 165.964Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.138 219.874C163.485 223.002 164.728 225.032 164.728 225.032",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.598 177.006C156.695 186.933 158.385 202.364 158.928 208.128C159.277 211.823 160.358 215.401 161.495 218.306",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154.611 168.119C154.611 168.119 154.873 170.461 155.27 174.043",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187.699 110.812C187.699 110.812 185.008 115.425 182.125 118.885C179.242 122.345 168.287 129.456 168.287 129.456C168.287 129.456 168.479 133.3 167.71 134.454C166.941 135.607 164.443 134.838 164.443 134.838C164.443 134.838 162.713 144.256 163.289 151.175C163.866 158.095 167.326 160.016 166.364 161.746C165.403 163.476 159.34 168.082 151.074 164.815C142.81 161.548 138.581 158.28 136.467 153.091C134.352 147.901 141.761 120.231 147.143 111.39C152.525 102.548 165.403 96.782 173.283 97.7435C181.164 98.7043 195.195 102.933 196.348 106.201C197.502 109.467 187.699 110.812 187.699 110.812Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M163.071 132.391C163.071 132.391 155.656 140.64 154.129 149.546C152.601 158.453 157.182 162.27 158.963 163.033",
    stroke: "#5C5C5C",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M141.184 148.307C140.992 149.953 141.129 151.639 141.66 153.363",
    stroke: "#5C5C5C",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M175.865 116.019C174.331 117.407 172.381 118.918 169.906 120.537C159.837 127.12 146.378 135.031 142.313 144.267",
    stroke: "#5C5C5C",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M181.357 106.287C181.357 106.287 182.205 108.951 178.386 113.444",
    stroke: "#5C5C5C",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M181.81 167.862C181.81 167.862 195.885 176.308 199.033 178.463C202.181 180.617 196.879 200.835 197.376 204.814C197.873 208.791 199.364 218.237 197.873 222.215C196.381 226.192 195.553 228.678 195.553 228.678L192.735 246.908C192.735 246.908 197.376 281.876 197.209 282.374C197.044 282.871 180.802 285.025 180.802 285.025C180.802 285.025 183.786 249.56 185.443 242.102C187.1 234.644 192.569 223.706 191.243 211.442C189.919 199.179 181.81 167.862 181.81 167.862Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M194.581 211.464C194.065 218.629 191.74 222.999 191.74 222.999",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M190.066 174.642C190.066 174.642 194.452 198.356 194.671 207.717",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M196.382 200.836C196.382 200.836 195.368 192.558 194.043 188.249",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M183.708 133.697C183.708 135.007 183.07 136.07 182.284 136.07C181.497 136.07 180.86 135.007 180.86 133.697C180.86 132.387 181.497 131.324 182.284 131.324C183.07 131.324 183.708 132.387 183.708 133.697Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M195.808 133.697C195.808 135.007 195.171 136.07 194.385 136.07C193.598 136.07 192.961 135.007 192.961 133.697C192.961 132.387 193.598 131.324 194.385 131.324C195.171 131.324 195.808 132.387 195.808 133.697Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M178.014 129.189C178.014 129.189 181.573 126.579 186.08 128.002",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M196.046 129.189C194.385 127.528 192.724 128.714 192.724 128.714C192.724 128.714 190.589 131.561 191.064 133.46",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M191.3 144.848L186.793 145.56",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M188.453 148.645C188.453 148.645 181.81 150.543 177.776 145.56",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M180.97 158.576L174.455 156.474L180.149 163.355L180.97 158.576Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M298.802 167.673C298.802 167.673 296.378 171.216 295.446 175.503C294.514 179.79 293.582 184.638 293.582 184.638C293.582 184.638 298.243 180.91 298.803 180.723C299.362 180.537 298.429 175.876 298.429 175.876L301.599 173.266L298.802 167.673Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M300.666 104.844C300.666 104.844 296.004 106.522 294.14 109.877C292.276 113.233 287.429 121.064 288.174 123.673C288.92 126.284 289.293 127.402 289.293 127.402C289.293 127.402 282.582 139.148 283.327 140.266C284.073 141.385 286.31 143.436 286.31 143.436C286.31 143.436 289.292 157.419 290.598 158.351C291.903 159.283 295.631 159.842 295.631 159.842L301.038 166.554L330.682 154.436L331.055 147.91C331.055 147.91 341.123 134.86 342.427 127.402C343.732 119.945 334.224 107.081 323.97 102.047C313.717 97.0139 302.904 99.8103 300.666 104.844Z",
    fill: "#FFA88F",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M291.052 131.417C291.052 131.417 293.157 133.222 295.564 133.222",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M323.97 102.047C313.716 97.0139 302.903 99.8103 300.666 104.844C300.666 104.844 301.598 105.589 304.58 105.403C307.563 105.217 314.648 102.234 316.512 104.844C318.376 107.454 310.92 109.691 308.123 113.606C305.327 117.521 306.072 117.708 308.309 120.691C310.546 123.673 310.92 124.979 310.546 126.284C310.173 127.588 309.614 128.707 312.038 129.08C314.461 129.453 315.208 123.487 318.937 125.351C322.665 127.215 323.225 132.809 321.919 136.538C320.614 140.266 317.818 141.385 317.818 141.385C317.818 141.385 318.377 143.808 322.479 145.859C326.581 147.91 331.055 147.91 331.055 147.91C331.055 147.91 341.123 134.86 342.428 127.402C343.733 119.945 334.224 107.082 323.97 102.047Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M331.062 135.451C331.684 137.207 331.947 138.888 331.749 140.339",
    stroke: "#5C5C5C",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M309.857 116.072C309.857 116.072 311.176 118.71 318.562 121.875C322.717 123.655 326.62 127.438 329.1 131.441",
    stroke: "#5C5C5C",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M330.167 123.985C330.167 123.985 336.762 127.942 335.706 135.591",
    stroke: "#5C5C5C",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M294.14 127.869C294.14 129.157 293.598 130.199 292.929 130.199C292.26 130.199 291.717 129.156 291.717 127.869C291.717 126.582 292.26 125.539 292.929 125.539C293.598 125.538 294.14 126.582 294.14 127.869Z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M290.225 122.742C290.225 122.742 293.581 118.827 296.564 122.928",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M288.921 143.996C288.921 143.996 293.395 143.623 296.191 140.827",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M317.818 141.386L315.767 141.945C315.767 141.945 314.835 145.487 311.293 149.216",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M317.818 141.386L315.767 141.945C315.767 141.945 314.835 145.487 311.293 149.216",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M331.242 151.64C331.242 151.64 302.157 163.758 300.852 165.25C299.548 166.741 298.802 167.673 298.802 167.673L301.039 179.605L334.97 157.233L331.242 151.64Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M246.666 233.792L248.285 245.663L240.731 247.462C240.731 247.462 237.314 249.8 234.256 251.239C231.199 252.678 229.04 253.217 227.961 253.217C226.882 253.217 222.925 251.599 222.925 251.599C222.925 251.599 225.623 237.03 228.681 235.411C231.738 233.792 239.832 231.454 246.666 233.792Z",
    fill: "#FFA88F",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M208.624 238.769C208.624 238.769 222.842 236.668 224.443 236.444C226.044 236.222 230.149 239.667 230.149 239.667C230.149 239.667 238.173 249.61 237.716 250.334C236.566 252.155 235.306 251.127 235.306 251.127L235.213 252.306C235.213 252.306 234.337 253.771 228.851 253.792C223.365 253.814 221.396 252.455 220.045 252.346C218.695 252.238 208.065 249.518 208.065 249.518L208.624 238.769Z",
    fill: "#FFA88F",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M203.858 237.715L209.075 238.648L208.501 250.404L203.755 250.095L203.858 237.715Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M146.049 170.097C146.049 170.097 131.215 169.062 128.11 171.477C125.006 173.891 126.558 205.8 129.145 217.357C131.733 228.913 135.355 247.369 137.08 248.231C138.805 249.093 204.588 251.753 204.588 251.753L205.278 237.437L154.501 226.499L150.879 181.308",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M146.049 170.097C146.049 170.097 131.215 169.062 128.11 171.477C125.006 173.891 126.558 205.8 129.145 217.357C131.733 228.913 135.355 247.369 137.08 248.231C138.805 249.093 204.588 251.753 204.588 251.753L205.278 237.437L154.501 226.499L150.879 181.308",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M235.306 251.127L233.022 247.906",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M233.728 252.986L230.964 249.455",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M242.889 234.871C242.889 234.871 229.399 230.735 226.701 233.612C224.004 236.49 218.248 244.045 219.507 244.944C220.766 245.843 225.262 242.426 226.342 241.707C227.421 240.987 228.5 239.728 228.5 239.728C228.5 239.728 232.277 243.865 238.213 242.246",
    fill: "#FFA88F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M242.889 234.871C242.889 234.871 229.399 230.735 226.701 233.612C224.004 236.49 218.248 244.045 219.507 244.944C220.766 245.843 225.262 242.426 226.342 241.707C227.421 240.987 228.5 239.728 228.5 239.728C228.5 239.728 232.277 243.865 238.213 242.246",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M228.052 249.14C228.052 249.14 226.773 253.764 227.265 254.55C227.757 255.338 228.642 255.534 229.232 255.338C229.822 255.141 230.413 254.55 230.413 254.55C230.413 254.55 230.609 250.615 230.019 249.631C229.429 248.648 228.938 247.959 228.052 249.14Z",
    fill: "#FFA88F",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M224.609 249.73C224.609 249.73 223.33 254.354 223.821 255.14C224.314 255.928 225.199 256.124 225.789 255.928C226.379 255.731 226.969 255.14 226.969 255.14C226.969 255.14 227.165 251.205 226.575 250.221C225.986 249.238 225.495 248.55 224.609 249.73Z",
    fill: "#FFA88F",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M221.146 249.896C221.146 249.896 220.165 253.441 220.542 254.045C220.919 254.648 221.598 254.8 222.051 254.648C222.504 254.498 222.957 254.045 222.957 254.045C222.957 254.045 223.107 251.027 222.655 250.273C222.202 249.518 221.825 248.99 221.146 249.896Z",
    fill: "#FFA88F",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M217.064 250.046C217.064 250.046 216.292 252.393 216.589 252.792C216.886 253.191 217.421 253.291 217.777 253.191C218.134 253.091 218.49 252.792 218.49 252.792C218.49 252.792 218.61 250.795 218.253 250.296C217.896 249.796 217.599 249.447 217.064 250.046Z",
    fill: "#FFA88F",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M245.587 232.533L247.385 249.26L253.321 248.181L251.163 231.454L245.587 232.533Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M249.365 230.374L252.962 251.599L277.603 248.36L280.3 224.259L249.365 230.374Z",
    fill: "#3561E4",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M268.711 249.529L277.602 248.36L280.3 224.259L273.805 225.543L268.711 249.529Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M343.103 298.014L341.094 259.332C341.094 259.332 349.547 222.28 347.749 201.776C345.95 181.272 332.101 159.868 332.101 159.868C332.101 159.868 299.545 180.193 296.128 183.79C292.711 187.387 286.595 193.503 284.797 199.258C282.998 205.013 275.983 240.446 275.983 240.446C275.983 240.446 268.609 265.267 266.27 280.195C264.848 289.279 265.024 294.954 265.379 298.014H343.103Z",
    fill: "#3561E4",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M330.861 166.644C336.541 164.141 337.394 163.572 337.394 163.572",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M286.589 207.468C289.402 202.388 292.88 196.357 294.513 194.519C297.497 191.164 319.869 171.401 328.072 167.859",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M282.396 215.214C282.396 215.214 283.726 212.689 285.537 209.379",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M303.08 217.136C303.095 228.695 301.46 240.142 302.277 251.589C298.189 266.307 290.83 279.39 285.536 293.199",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M306.072 193.402C306.072 193.402 302.717 198.435 303.09 207.758C303.136 208.898 303.15 210.457 303.141 212.315",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M338.512 198.621C338.512 198.621 331.055 256.044 330.309 260.704C329.775 264.042 318.342 282.295 311.893 292.389",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M289.245 281.723L273.994 279.071L274.988 274.428L289.908 277.081",
    stroke: "#263238",
    strokeWidth: 0.788834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_837_238",
    x: 0.0373135,
    y: 0.0373135,
    width: 460.925,
    height: 310.925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.98134
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_837_238"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_837_238",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvtBenefits5);
export default __webpack_public_path__ + "static/media/dvt_benefits5.80a10c35eb63d45b8f3898d94d7b761e.svg";
export { ForwardRef as ReactComponent };